<template>
  <div class="DashInnerHCU">
    <h3>Your Trust is: {{ this.UserTrustLocation }}</h3>
    <p>Please select location you wish to view</p>
    <div>
      <div class="Auto">
        <label for="autocompleteLocation">Location: </label>
        <input
          type="text"
          autocomplete="off"
          v-model="location"
          @focus="modal = true"
        />
        <br />
        <div class="AutoDrop" v-if="filteredlocations && modal">
          <ul>
            <li
              v-for="(filteredlocation, idx) in filteredlocations"
              :key="idx"
              @click="setLocation(filteredlocation)"
            >
              {{ filteredlocation.toString() }}
            </li>
          </ul>
        </div>
        <br />
        <button class="button" v-on:click="submitLocation()">Filter</button>
        <button class="button" v-on:click="resetValue()">Clear</button>
      </div>
    </div>
    <div id="UnitRAG">
      <p>Current Unit Status:</p>
      <b-button-group>
        <b-button
          variant="danger"
          v-on:click="$router.push('UnitStatus')"
          size="lg"
          >{{ this.GetButtonValue() }}</b-button
        >
        <b-button
          variant="success"
          v-on:click="$router.push('UnitStatus')"
          size="lg"
          >{{ this.GetButtonValue1() }}</b-button
        >
      </b-button-group>
      <br />
      <br />
    </div>
    <div class="Container">
      <b-container>
        <b-row>
          <b-col
            ><div>
              <b-card
                no-body
                style="max-width: 540px;"
                bg-variant="info"
                text-variant="white"
                header="Cost Savings"
                class="text-center"
              >
                <b-row no-gutters>
                  <b-col>
                    <b-card-body>
                      <h3>Water Cost Savings : £{{ this.WaterCostMoney }}</h3>
                      <h3>Water Savings : {{ this.WaterCostLitres }} Litres</h3>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </div>
          </b-col>
          <b-col
            ><div>
              <b-card
                no-body
                style="max-width: 540px;"
                bg-variant="info"
                text-variant="white"
                header="Consumables Savings"
                class="text-center"
              >
                <b-row no-gutters>
                  <b-col>
                    <b-card-body>
                      <b-card-text>
                        <br />
                        <h3>
                          Soap & Gel Savings :
                          {{ this.ConsumableCostLitres }} Litres
                        </h3>
                      </b-card-text>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" md="6">
            <bar-chart
              :chartData="this.setChartData()"
              :options="chartOptions"
              style="max-width: 540px;"
            ></bar-chart>
          </b-col>
          <b-col cols="12" md="6">
            <bar-chart-2
              :chartData="this.setChartData1()"
              :options="chartOptions1"
              style="max-width: 540px;"
            ></bar-chart-2>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" md="12"
            ><div>
              <b-card
                no-body
                style="max-width: 1500px;"
                bg-variant="success"
                text-variant="white"
                header="Potential Pathogen Interventions"
                class="text-center"
              >
                <b-row no-gutters>
                  <b-col>
                    <b-card-body>
                      <b-container>
                        <b-row>
                          <b-col sm="3">
                            <h3>Today:</h3>
                          </b-col>
                          <b-col sm="3">
                            <h3>Week:</h3>
                          </b-col>
                          <b-col sm="3">
                            <h3>Month:</h3>
                          </b-col>
                          <b-col sm="3">
                            <h3>Total:</h3>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col sm="3">
                            <h3>{{ this.CountermeasureDay }}</h3>
                          </b-col>
                          <b-col sm="3">
                            <h3>{{ this.CountermeasureWeek }}</h3>
                          </b-col>
                          <b-col sm="3">
                            <h3>{{ this.CountermeasureMonth }}</h3>
                          </b-col>
                          <b-col sm="3">
                            <h3>{{ this.CountermeasureTotal }}</h3>
                          </b-col>
                        </b-row>
                      </b-container>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" md="12">
            <p></p>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import BarChart from "./HandwashBarChart.vue";

export default {
  components: {
    BarChart,
  },

  data() {
    return {
      location: "",
      locations: [],
      filteredlocations: [],
      modal: false,
      UserTrustLocation: "",
      WaterCostMoney: "",
      WaterCostLitres: "",
      ConsumableCostMoney: "",
      ConsumableCostLitres: "",
      CountermeasureDay: "",
      CountermeasureWeek: "",
      CountermeasureMonth: "",
      CountermeasureTotal: "",
      HandwashArrayTest1: "",
      HandwashArrayTest2: "",
      AlertCount: "09",
      UnitCount: "15",
      dataset: [0, 0, 0, 0],
      dataset1: [0, 0, 0, 0],
      chartData: null,
      chartData1: null,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: { yAxes: [{ ticks: { beginAtZero: true } }] },
      },
      chartOptions1: {
        responsive: true,
        maintainAspectRatio: false,
        scales: { yAxes: [{ ticks: { beginAtZero: true } }] },
      },
      GreenCount: "--",
      RedCount: "--",
    };
  },

  async mounted() {
    let UserTrust = localStorage.getItem("trust");
    this.UserTrustLocation = UserTrust;
    let url =
      "https://m59kpjvq25.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/locationsbytrust?TrustName=";
    let GetUrl = url + UserTrust;
    axios.get(GetUrl, { headers: this.$apikey }).then((response) => {
      this.locations = response.data.Values;
      this.info = response;
    });

    let PostUrl =
      "https://fgnmkomagb.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/graphreporting";
    let PostHeaders = this.$apikeyPost;
    let PostData = {
      RequestType: "Trust",
      RequestVariable: this.UserTrustLocation,
    };
    axios
      .post(PostUrl, PostData, PostHeaders)
      .then((response) => {
        this.WaterCostMoney = response.data[2][1];
        this.WaterCostLitres = response.data[2][0];
        this.CountermeasureDay = response.data[4][1];
        this.CountermeasureWeek = response.data[4][2];
        this.CountermeasureMonth = response.data[4][3];
        this.CountermeasureTotal = response.data[4][0];
        this.ConsumableCostMoney = response.data[3][1];
        this.ConsumableCostLitres = response.data[3][0];
        this.HandwashCountToday = response.data[0][1];
        this.HandwashCountMinus7 = response.data[0][2];
        this.HandwashCountWeek = response.data[0][3];
        this.HandwashCountLastWeek = response.data[0][4];
        this.HandwashCountAVG = response.data[0][5] / 30;
        this.ComplianceToday = response.data[1][0];
        this.ComplianceMinusSeven = response.data[1][0];
        this.ComplianceMonthlyAvg = response.data[1][2] / 30;
      })
      .catch((err) => {
        return err;
      });
    this.GreenCount = "--";
    this.RedCount = "--";
    let CountUrl =
      "https://81vec86leg.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/statuscounts";
    let CountHeaders = this.$apikeyPost;
    let CountData = { RequestType: "HCU", Trust: this.UserTrustLocation };
    axios
      .post(CountUrl, CountData, CountHeaders)
      .then((response) => {
        this.RedCount = response.data.AlertCount[0][0];
        this.GreenCount =
          response.data.TotalCount[0][0] - response.data.AlertCount[0][0];
      })
      .catch((err) => {
        return err;
      });
  },

  methods: {
    resetValue: function() {
      this.location = "";
      this.modal = false;
      let PostUrl =
        "https://fgnmkomagb.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/graphreporting";
      let PostHeaders = this.$apikeyPost;
      let PostData = {
        RequestType: "Trust",
        RequestVariable: this.UserTrustLocation,
      };
      axios
        .post(PostUrl, PostData, PostHeaders)
        .then((response) => {
          this.WaterCostMoney = response.data[2][1];
          this.WaterCostLitres = response.data[2][0];
          this.CountermeasureDay = response.data[4][1];
          this.CountermeasureWeek = response.data[4][2];
          this.CountermeasureMonth = response.data[4][3];
          this.CountermeasureTotal = response.data[4][0];
          this.ConsumableCostMoney = response.data[3][1];
          this.ConsumableCostLitres = response.data[3][0];
          this.HandwashCountToday = response.data[0][1];
          this.HandwashCountMinus7 = response.data[0][2];
          this.HandwashCountWeek = response.data[0][3];
          this.HandwashCountLastWeek = response.data[0][4];
          this.HandwashCountAVG = response.data[0][5] / 30;
          this.ComplianceToday = response.data[1][0];
          this.ComplianceMinusSeven = response.data[1][0];
          this.ComplianceMonthlyAvg = response.data[1][2] / 30;
        })
        .catch((err) => {
          return err;
        });

      this.GreenCount = "--";
      this.RedCount = "--";
      let CountUrl =
        "https://81vec86leg.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/statuscounts";
      let CountHeaders = this.$apikeyPost;
      let CountData = { RequestType: "HCU", Trust: this.UserTrustLocation };
      axios
        .post(CountUrl, CountData, CountHeaders)
        .then((response) => {
          this.RedCount = response.data.AlertCount[0][0];
          this.GreenCount =
            response.data.TotalCount[0][0] - response.data.AlertCount[0][0];
        })
        .catch((err) => {
          return err;
        });
    },

    filterLocations: function() {
      if (this.location.length == 0) {
        this.filteredlocations = this.locations;
      }
      this.filteredlocations = this.locations.filter((location) => {
        return location
          .toString()
          .toLowerCase()
          .startsWith(this.location.toString().toLowerCase());
      });
    },

    setChartData() {
      let dataset = [
        this.HandwashCountToday,
        this.HandwashCountMinus7,
        this.HandwashCountWeek,
        this.HandwashCountLastWeek,
      ];
      return {
        labels: ["Today", "7 Days Prior", "This Week", "Last Week"],
        datasets: [
          {
            label: "Handwash Count",
            backgroundColor: "#DAA806",
            pointBackgroundColor: "white",
            borderWidth: 1,
            pointBorderColor: "#249EBF",
            data: dataset,
          },
        ],
      };
    },

    setChartData1() {
      let dataset1 = [
        this.ComplianceToday,
        this.ComplianceMinusSeven,
        this.ComplianceMonthlyAvg,
      ];
      let dataset2 = [
        this.HandwashCountToday,
        this.HandwashCountMinus7,
        this.HandwashCountAVG,
      ];

      return {
        labels: ["Today", "7 Days Prior", "Avg Day"],
        datasets: [
          {
            label: "Actual Handwash Numbers",
            backgroundColor: "#DC7633",
            pointBackgroundColor: "white",
            borderWidth: 1,
            pointBorderColor: "#249EBF",
            data: dataset2,
          },
          {
            label: "Expected Handwash Opportunities",
            backgroundColor: "#DAA806",
            pointBackgroundColor: "white",
            borderWidth: 1,
            pointBorderColor: "#249EBF",
            data: dataset1,
          },
        ],
      };
    },

    GetButtonValue() {
      return this.RedCount;
    },

    GetButtonValue1() {
      return this.GreenCount;
    },

    submitLocation() {
      let FilterUrl =
        "https://fgnmkomagb.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/graphreporting";
      let FilterHeaders = this.$apikeyPost;
      let FilterData = {
        RequestType: "LocationName",
        RequestVariable: this.location[0],
      };
      axios
        .post(FilterUrl, FilterData, FilterHeaders)
        .then((response) => {
          this.WaterCostMoney = response.data[2][1];
          this.WaterCostLitres = response.data[2][0];
          this.CountermeasureDay = response.data[4][1];
          this.CountermeasureWeek = response.data[4][2];
          this.CountermeasureMonth = response.data[4][3];
          this.CountermeasureTotal = response.data[4][0];
          this.ConsumableCostMoney = response.data[3][1];
          this.ConsumableCostLitres = response.data[3][0];
          this.HandwashCountToday = response.data[0][1];
          this.HandwashCountMinus7 = response.data[0][2];
          this.HandwashCountWeek = response.data[0][3];
          this.HandwashCountLastWeek = response.data[0][4];
          this.HandwashCountAVG = response.data[0][5] / 30;
          this.ComplianceToday = response.data[1][0];
          this.ComplianceMinusSeven = response.data[1][0];
          this.ComplianceMonthlyAvg = response.data[1][2] / 30;
        })
        .catch((err) => {
          return err;
        });

      this.GreenCount = "--";
      this.RedCount = "--";
      let FilterCountUrl =
        "https://81vec86leg.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/statuscounts";
      let FilterCountHeaders = this.$apikeyPost;
      let FilterCountData = { RequestType: "HCU", Location: this.location[0] };
      axios
        .post(FilterCountUrl, FilterCountData, FilterCountHeaders)
        .then((response) => {
          this.RedCount = response.data.AlertCount[0][0];
          this.GreenCount =
            response.data.TotalCount[0][0] - response.data.AlertCount[0][0];
        })
        .catch((err) => {
          return err;
        });
    },

    setLocation(location) {
      this.location = location;
      this.modal = false;
    },
  },

  watch: {
    location() {
      this.filterLocations();
    },
  },
};
</script>

<style scoped>
input[type="text"],
select {
  width: 60%;
  margin: 2px 0;
  border-style: solid;
  border-color: black;
  background-color: whitesmoke;
  padding: 2px 8px;
  position: relative;
  z-index: 1000;
}
</style>
